import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!url || !anonKey) {
  throw new Error('VITE_SUPABASE_URL и VITE_SUPABASE_ANON_KEY обязательны (.env.local для локального стека)');
}

// Один клиент на приложение. Токен обновляет сам; RLS — в базе, ключ публичный по устройству.
// Heartbeat 10 с вместо 25: тихую смерть сокета (сеть пропала без закрытия) замечаем за 10–20 с, а не за минуту.
export const supabase = createClient<Database>(url, anonKey, { realtime: { heartbeatIntervalMs: 10_000 } });
